import React, { ChangeEvent, useState } from "react";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import AddressBlock from "../../../shared/AddressBlock/AddressBlock";
import AddressDisplay from "../../../shared/AddressDisplay/AddressDisplay";
import INewAddress from "../../../../models/INewAddress";
import UIService from "../../../../services/UIService";

type Props = {
    shipTo: INewAddress;
    updateAddress: (e: ChangeEvent<any>) => void;
};

export const DashboardEntryShipToWidget = (props: Props) => {
    const isMainViewLight = UIService.isMainViewLight();

    const [shipToEditMode, setShipToEditMode] = useState(false);

    const toggleShipToEditMode = () => {
        setShipToEditMode(!shipToEditMode);
    };

    return (
        <div className={"DashboardEntryShipToWidget col-3"}>
            <div
                className={
                    "card d-flex justify-content-between font-weight-bold card-header " + (!isMainViewLight ? "text-white bg-dark" : "")
                }>
                <OwLabel title={"ship_to"} />

                <OwLabel
                    title={shipToEditMode ? "save" : "edit"}
                    fn={() => {
                        toggleShipToEditMode();
                    }}
                />
            </div>
            <div>
                <div className={"card-body"}>
                    {shipToEditMode ? (
                        <AddressBlock showName={true} showCompanyName={true} address={props.shipTo} fn={props.updateAddress} />
                    ) : (
                        <AddressDisplay address={props.shipTo} showName={true} showCompanyName={true} />
                    )}
                </div>
            </div>
        </div>
    );
};
